<script setup>
import {ref} from "vue";
import { t } from "@/controllerLK/AvalLocalization";

const natureList = [
  {
    id: "government",
    name: t("news_page_story.nature_section.options.government.title"),
    meta: t("news_page_story.nature_section.options.government.options")
        .split(". ")
        .map(item => item.replace(/\.$/, "").trim())
        .filter(item => item.length > 0),
    useSwitcher: false,
  },
  {
    id: "opposition",
    name: t("news_page_story.nature_section.options.opposition.title"),
    meta: t("news_page_story.nature_section.options.opposition.options")
        .split(". ")
        .map(item => item.replace(/\.$/, "").trim())
        .filter(item => item.length > 0),
    useSwitcher: false,
  },
  {
    id: "neutral",
    name: t("news_page_story.nature_section.options.neutral.title"),
    meta: t("news_page_story.nature_section.options.neutral.options")
        .split(". ")
        .map(item => item.replace(/\.$/, "").trim())
        .filter(item => item.length > 0),
    useSwitcher: true,
  }
];

const selectedNature = ref("government");

const selectNature = (value) => {
  selectedNature.value = value;

  if (selectedNature.value !== "neutral") {
    politicalAnalysisStatus.value = false;
  }
};

const politicalAnalysisStatus = ref(false);
</script>

<template>
  <div
    v-for="nature in natureList"
    :key="nature.id"
    class="nature-selector"
    :class="{'nature-selector--active': nature.id === selectedNature}"
  >
    <h2 class="nature-selector__title">
      <AvalRadioButton
        :model-value="selectedNature"
        :value="nature.id"
        :label="nature.name"
        @update:model-value="selectNature"
      />
    </h2>
    <ul class="nature-selector__body">
      <li
        v-for="description in nature.meta"
        :key="description"
        class="nature-selector__item"
      >
        {{ description }}
      </li>

      <template v-if="nature.useSwitcher">
        <div class="nature-selector__footer">
          {{ t("news_page_story.nature_section.options.neutral.switcher") }}

          <label class="toggle-switch">
            <input
              v-model="politicalAnalysisStatus"
              :disabled="selectedNature !== 'neutral'"
              type="checkbox"
            >
            <span class="slider" />
          </label>
        </div>
      </template>
    </ul>
  </div>
</template>

<style scoped lang="scss">
.nature-selector {
  display: flex;
  flex-direction: column;
  padding: 5px;
  background-color: var(--background-01);
  border-radius: 10px;

  &:hover:not(&--active) {
    background-color: var(--background-bg-active-hover2);
  }

  &--active {
    background-color: var(--background-bg-active-hover);
  }

  &__title {
    padding: 5px 16px;
  }

  &__body {
    display: flex;
    flex-direction: column;
    gap: 7px;
    border-radius: 8px;
    background-color: var(--background-bg-white);
    padding: 12px 15px;
    list-style-type: disc;
    list-style-position: inside;
    color: var(--text-text-main);
  }

  &__item {
    padding-left: 8px;
  }

  &__footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 8px 0 8px;
    border-top: 1px solid var(--border-bd-divider);
  }
}

.toggle-switch {
  position: relative;
  width: 44px;
  height: 24px;
  cursor: pointer;
  display: inline-block;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--background-bg-selected);
  border-radius: 34px;
  transition: background-color 0.3s ease;
  box-shadow: -2px 2px 20px 0px var(--gray-gray50) inset;
}

.slider:before {
  content: "";
  position: absolute;
  height: 20px;
  width: 20px;
  left: 2px;
  top: 2px;
  background-color: var(--background-bg-white);
  border-radius: 50%;
  transition: transform 0.3s ease, background-color 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

input:checked + .slider {
  background-color: var(--icon-icon-on);
}

input:disabled + .slider {
  background-color: var(--purple-purple50);
  cursor: not-allowed;
}

input:checked + .slider:before {
  transform: translateX(20px);
  background-color: var(--background-bg-white);
}
</style>